var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"estimated-read-time"},[_vm._v(" "+_vm._s(this.wordCount)+" words, "+_vm._s(this.estimatedReadTime)+" minutes read ")])}
var staticRenderFns = []

export { render, staticRenderFns }